/** OrdreUpdate. */
export class OrdreUpdate {
    id: number;
    ordre: number;

    constructor(id: number, ordre: number) {
        this.id = id;
        this.ordre = ordre;
    }
}